function openMenu(container, openButtonSelector, closeBtnSelector, openingMenu) {
    const mainContainer = document.querySelectorAll(container);


    mainContainer.forEach((box) => {
        const openBtn = box.querySelector(openButtonSelector);
        const closeBtn = box.querySelector( closeBtnSelector);
        const menu = box.querySelector(openingMenu);

        openBtn.addEventListener('click', (e) => {
            e.preventDefault();
            menu.classList.remove('hide');
        });

        closeBtn.addEventListener('click', () => {
            menu.classList.add('hide');
        })
      
    })
}

export default openMenu;